import {defer, Observable, Subject} from 'rxjs'
import {finalize, tap} from 'rxjs/operators'

// Thank you https://nils-mehlhorn.de/posts/indicating-loading-the-right-way-in-angular

export function prepare<T>(callback: () => void): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    defer(() => {
      callback()
      return source
    })
}

/**
 * Indicates when an observable is "loading". "loading" means that an observable has not yet emitted a value.
 * - When the source observable is subscribed to, "true" is sent to the indicator subject.
 * - When a value has been emitted, or the source observable completes or emits an error, "false" is sent to the indicator subject.
 */
export function indicate<T>(indicator: Subject<boolean>): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      prepare(() => indicator.next(true)),
      tap(() => indicator.next(false)),
      finalize(() => indicator.next(false)),
    )
}
